import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

const readCustomCaptions = () => {
	const me =
		JSON.parse(sessionStorage.getItem("me")) ||
		JSON.parse(localStorage.getItem("me")) ||
		{};
	return me.customCaptions;
};

// The Gantt re-initialises whenever its columns prop changes identity, so the
// captions are read once rather than parsed afresh on every render
const useGanttColumns = () => {
	const { t } = useTranslation();
	const [customCaptions] = useState(readCustomCaptions);

	const columns = useMemo(() => [
		{
			id: "text",
			header: customCaptions?.serviceWorkOrder || "Work Order",
			width: 250,
		},
		{
			id: "interval",
			header: customCaptions?.interval || "Interval",
			flexgrow: 1,
		},
		{
			id: "status",
			header: t("label.status"),
			width: 100
		},
		{
			id: "percComplete",
			header: t("label.percentComplete"),
			width: 80
		},
		{
			id: "start",
			header: t("label.startDate"),
			width: 80,
		},
		{
			id: "estimatedMinutes",
			header: t("label.estHours"),
			width: 70
		},
	], [customCaptions, t]);

	return columns;
};

export default useGanttColumns;
